import React from 'react';

const BuilderContext = React.createContext();

export default BuilderContext;
